import { render, staticRenderFns } from "./chjtablecolumn.vue?vue&type=template&id=105a3f3f&"
import script from "./chjtablecolumn.vue?vue&type=script&lang=js&"
export * from "./chjtablecolumn.vue?vue&type=script&lang=js&"
import style0 from "./chjtablecolumn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "chjtablecolumn.vue"
export default component.exports